import SiteDto from "../Common/dtos/SiteDto";
import { QueryOptions } from "../Common/useQuery";
import useUserOrEmployeeQuery from "../Common/useUserOrEmployeeQuery";
import { useUserOrKaEmployee } from "../UserAccess/useUserOrKaEmployee";

const useGetSitesNonAdmin = (options?: QueryOptions<SiteDto[]>) => { 
  const { selectedBusiness } = useUserOrKaEmployee();

  return useUserOrEmployeeQuery<SiteDto[]>(
    { path: `/api/businesses/${selectedBusiness?.id!}/sites/nonAdmin` },
    options);
}

export default useGetSitesNonAdmin;
